<div class="row">
  <ng-template appDynamicHost></ng-template>
  <div class="cursor-pointer ml-3" (click)="createComponent(true)">
    <div class="add-address-container">
      <i class="fas fa-plus-circle mr-3"></i><span class="add-address">Agregar direccion</span>
    </div>
  </div>
</div>